import { Outlet, ScrollRestoration } from 'react-router-dom';
import { CheckoutAuthProvider } from '@/features/auth/CheckoutAuth';

import { DocumentMetadata } from './DocumentMetadata';
import { Header } from './Header';
import { Footer } from './Footer';
import { Analytics } from './Analytics';
import { ReloadScrollRestoration } from './ReloadScrollRestoration';

export function RootLayout() {
  return (
    <CheckoutAuthProvider>
      <div className="bg-bg-canvas text-fg-primary flex min-h-screen min-w-0 max-w-full flex-col">
        <DocumentMetadata />
        <Analytics />
        <ScrollRestoration />
        <ReloadScrollRestoration />
        <Header />
        <main className="min-w-0 flex-1">
          <Outlet />
        </main>
        <Footer />
      </div>
    </CheckoutAuthProvider>
  );
}
